// extracted by mini-css-extract-plugin
module.exports = {"page-heading":"PageHeading_page-heading__qP0OK"};